export default __webpack_public_path__ + "static/media/markdownReadme.369ae186.md";